import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            padding: 3
        },
        grid: {
            display: 'flex',
            gap: 1,
            alignItems: 'center',
            '& .MuiSvgIcon-root': {
                fontSize: '4rem',
                color: colors.color13
            },
            paddingRight: 1
        },
        gridSecond: {
            display: 'flex',
            alignItems: 'center',
        },
        flex1: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        }
    }
}

export { useStyles }
